











import {Component, Prop} from 'vue-property-decorator'
import Vue from 'vue' 

const BORDERRADIUS = [
    'rounded-none',
    'rounded-sm',
    'rounded',
    'rounded-md',
    'rounded-lg',
    'rounded-xl',
    'rounded-2xl',
    'rounded-3xl',
    'rounded-full'
]
const ELEVATION = [
    'shadow-none',
    'shadow-sm',
    'shadow',
    'shadow-md',
    'shadow-lg',
    'shadow-xl',
    'shadow-2xl',
]

/**
 * 툴팁 컴포넌트 입니다.
*/
@Component
export default class HdsTooltip extends Vue {
    name: string = 'HdsTooltip';

    /**
     * 패딩을 지정합니다.
    */
    @Prop({
        type: String
    })
    padding?: string

    /**
     * 테두리 스타일을 선택합니다.
    */
    @Prop({
        type: String,
        default: 'none'
    })
    borderStyle!: string

    /**
     * 테두리 색을 지정합니다.
    */
    @Prop({
        type: String,
    })
    borderColor?: string

    /**
     * 테두리 굵기를 선택합니다.
    */
    @Prop({
        type: String,
        default: 'thin',
        validator: function (value) {
            return ['thin', 'medium', 'thick'].indexOf(value) !== -1
        },
    })
    borderWidth!: string

    /**
     * Border Radius 값입니다. 0~8
    */
    @Prop({
        type: Number,
        default: 2
    })
    borderRadius!: number

    /**
     * Elevation 값입니다. (box-shadow) 0~6
    */
    @Prop({
        type: Number,
        default: 2
    })
    elevation!: number

    /**
     * 툴팁 배경 색상을 지정합니다.
    */
    @Prop({
        type: String,
    })
    backgroundColor?: string

    get tooltipClasses() {
        return {
            'hades-tooltip-text': true,
            'hades-tooltip--thin': this.borderWidth === 'thin',
            'hades-tooltip--medium': this.borderWidth === 'medium',
            'hades-tooltip--thick': this.borderWidth === 'thick',
            [`hades-tooltip--border-${this.borderStyle}`]: true,
            [BORDERRADIUS[this.borderRadius]]: true,
            [ELEVATION[this.elevation]]: true,
        }
    }

    get tooltipStyles() {
        return {
            padding: this.padding,
            backgroundColor: this.backgroundColor,
            borderColor: this.borderColor,
        }
    }

    overContent(e: any) {
        const targetDir = e.target.offsetParent.getAttribute('data-dir');
        const targetTooltip = e.target.offsetParent.querySelector('.hades-tooltip-text');

        switch(targetDir){
            case 'top' : targetTooltip.style.bottom = e.target.clientHeight + 10 +"px";
            break;
            case 'bottom' : targetTooltip.style.top = e.target.clientHeight + 10 +"px";
            break;
            case 'left' : targetTooltip.style.right = e.target.clientWidth + 10 +"px";
            break;
            case 'right' : targetTooltip.style.left = e.target.clientWidth + 10 +"px";
            break;
        }

    }
}
